import styled from 'styled-components';

export const TasksContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  li {
    /* float: left; */
    /* position: relative; */
    display: inline-block;
    /* height: 200px; */
  }
`;
